"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _ApproveAs = require("./ApproveAs.styled");
var _hooks = require("../../../../../hooks");
var _ = require("../../../..");
var _KnockTypes = require("../../../../../constants/KnockTypes");
var _utils = require("../../../../../utils");
var _logger = require("@studio/logger");
var _knockTypeMap;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ApproveAs = function ApproveAs(_ref) {
  var assignedSourceId = _ref.assignedSourceId,
    sources = _ref.sources,
    allSources = _ref.allSources,
    onApprove = _ref.onApprove,
    name = _ref.name,
    elementId = _ref.elementId,
    isDisabled = _ref.isDisabled,
    knockType = _ref.knockType,
    onAssignKnockToSource = _ref.onAssignKnockToSource;
  var actionText = knockTypeMap[knockType].actionText;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dropdownOpen = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    offsetTop = _useState4[0],
    setOffsetTop = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    buttonDisabled = _useState6[0],
    setButtonDisabled = _useState6[1];
  var _useKnockDisplayName = (0, _hooks.useKnockDisplayName)({
      sources: allSources.length ? allSources : sources,
      assignedSourceId: assignedSourceId,
      name: name,
      onAssignKnockToSource: onAssignKnockToSource
    }),
    displayName = _useKnockDisplayName.displayName,
    sourceId = _useKnockDisplayName.sourceId,
    updateDisplayState = _useKnockDisplayName.updateDisplayState;
  var toggle = function toggle() {
    return setOpen(!dropdownOpen);
  };
  var handleChange = function handleChange(value) {
    var _sources$find;
    var displayName = (_sources$find = sources.find(function (source) {
      return source._id === value;
    })) === null || _sources$find === void 0 ? void 0 : _sources$find.title;
    updateDisplayState({
      displayName: displayName,
      sourceId: value,
      loaded: true
    });
    setOpen(false);
  };
  var handleApprove = function handleApprove(e) {
    e.preventDefault();
    setButtonDisabled(true);
    var speakerData = {
      action: 'approve',
      type: knockTypeMap[knockType].actionText,
      name: name
    };
    !sourceId ? onApprove() : onApprove(sourceId);
    (0, _logger.sendToDatadog)('ApproveAs', {
      speakerData: speakerData
    }, "Approve button clicked for speaker: ".concat(name));
  };
  var handleOffSet = function handleOffSet(e) {
    e.persist();
    setOffsetTop(e.clientY - 55);
  };
  var approvalMessage = !displayName ? _react["default"].createElement(_react["default"].Fragment, null, "Approve as a new ", actionText, " \xA0") : _react["default"].createElement(_react["default"].Fragment, null, "Approve as", _react["default"].createElement(_ApproveAs.StyledName, {
    className: "dd-privacy-mask"
  }, "\xA0", (0, _utils.truncate)(displayName, 15), "\xA0"));
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_ApproveAs.StyledButtonDropdown, {
    addonType: "prepend",
    isOpen: dropdownOpen,
    toggle: toggle,
    id: "approve-button"
  }, _react["default"].createElement(_ApproveAs.StyledButton, {
    onClick: isDisabled || buttonDisabled ? function () {} : handleApprove,
    "data-testid": "accept-as-approve-button-".concat(name),
    id: elementId,
    $isDisabled: isDisabled || buttonDisabled
  }, approvalMessage), _react["default"].createElement(_ApproveAs.StyledDropdownToggle, {
    "data-testid": "accept-as-toggle",
    onClick: handleOffSet,
    disabled: isDisabled
  }, _react["default"].createElement(_ApproveAs.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faChevronDown,
    "aria-hidden": true
  })), _react["default"].createElement(_ApproveAs.StyledDropdownMenu, {
    top: offsetTop,
    flip: false
  }, _react["default"].createElement(_ApproveAs.ApproveAsBody, {
    top: offsetTop
  }, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_ApproveAs.StyledDropdownMenuItem, {
    toggle: false,
    key: "knock-source-item-create-new-source",
    id: "create-new-source-dd"
  }, _react["default"].createElement("label", {
    htmlFor: "create-new-source-radio-button",
    onClick: function onClick() {
      return handleChange('');
    }
  }, _react["default"].createElement(_ApproveAs.StyledRadioInput, {
    "data-testid": "create-new-source-radio-button",
    type: "radio",
    name: "unassigned-source-chooser",
    value: "",
    id: "create-new-source-radio-button",
    defaultChecked: !displayName && true
  }), "Create a new ", actionText))), _react["default"].createElement(_react["default"].Fragment, null, sources.map(function (source, index) {
    return _react["default"].createElement(_react.Fragment, {
      key: source._id
    }, _react["default"].createElement(_ApproveAs.StyledDropdownMenuItem, {
      toggle: false,
      key: "knock-source-item-".concat(source._id),
      id: "source-dd-".concat(source._id)
    }, _react["default"].createElement("label", {
      className: "dd-privacy-mask",
      htmlFor: "unassigned-source-".concat(index, "-radio-button"),
      onClick: function onClick() {
        return handleChange(source._id);
      }
    }, _react["default"].createElement(_ApproveAs.StyledRadioInput, {
      "data-testid": "unassigned-source-".concat(index, "-radio-button"),
      type: "radio",
      name: "unassigned-source-chooser",
      value: source._id,
      id: "unassigned-source-".concat(index, "-radio-button"),
      defaultChecked: source._id === sourceId
    }), source.title)), _react["default"].createElement(_.ToolTip, {
      className: "dd-privacy-mask",
      key: "knock-source-tooltip-".concat(source._id),
      targetElement: "source-dd-".concat(source._id),
      message: "".concat(source.title),
      mode: "dark"
    }));
  }))))));
};
var knockTypeMap = (_knockTypeMap = {}, (0, _defineProperty2["default"])(_knockTypeMap, _KnockTypes.PRESENTER, {
  actionText: 'speaker'
}), (0, _defineProperty2["default"])(_knockTypeMap, _KnockTypes.SCREENSHARE, {
  actionText: 'screen share'
}), _knockTypeMap);
ApproveAs.propTypes = {
  sources: _propTypes["default"].array.isRequired,
  allSources: _propTypes["default"].array.isRequired,
  onApprove: _propTypes["default"].func.isRequired,
  name: _propTypes["default"].string.isRequired,
  elementId: _propTypes["default"].string,
  isDisabled: _propTypes["default"].bool,
  onAssignKnockToSource: _propTypes["default"].func,
  assignedSourceId: _propTypes["default"].string
};
var _default = exports["default"] = ApproveAs;